import { FLAG_DELIMITER, NAME_VALUE_DELIMITER } from './constants';
import type { FeatureFlags } from './types';

export const parseFeatureFlagsString = (headerValue: string): FeatureFlags => {
  const flags = headerValue ? headerValue.split(FLAG_DELIMITER) : [];

  return flags.reduce((featureFlags, flag) => {
    const [name, value] = flag.split(NAME_VALUE_DELIMITER);

    return value
      ? {
          ...featureFlags,
          [name]: value,
        }
      : featureFlags;
  }, {});
};
